export default __webpack_public_path__ + "static/media/search-big.3c6a9322.svg";